import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Stack, FormControl, FormLabel } from '@chakra-ui/react';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from '@/components/forms/new/formStyles';

/**
 * Label-and-control row used by the SRT trunk form.
 *
 * Owns the hover state each row needs for its tooltip, so pages don't carry one
 * piece of state per field.
 */
const TrunkFieldRow = ({
    label,
    tooltip,
    ariaLabel,
    isRequired = true,
    isLast = false,
    isInvalid = false,
    children,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const { darkMode } = useSelector((state) => state.settings);

    return (
        <FormControl
            isInvalid={isInvalid}
            sx={{ margin: '0 !important', mb: isLast ? 0 : 4 }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), height: 'auto' }}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    {label}
                    {isRequired && <span style={{ color: '#e53e3e' }}>*</span>}
                </FormLabel>
                <Box width="410px">{children}</Box>
                {isHovered && tooltip && (
                    <FieldToolTip
                        label={tooltip}
                        ariaLabel={ariaLabel}
                        left="25px"
                        top="22px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default TrunkFieldRow;
